import * as React from "react";
import { SpsCard, SpsIncrementor } from "../index";
export const SpsIncrementorPropTypes = SpsIncrementor["propTypes"];

function SpsIncrementorFunctionalExample(props) {
    const { "data-testid": testId } = props;
    const [value, setValue] = React.useState("");
    const handleChange = val => {
        setValue(val);
    };
    return (
        <React.Fragment>
            <SpsIncrementor onValueChange={handleChange} data-testid={testId} />
            Value: {value}
        </React.Fragment>
    );
}

// @ts-ignore
SpsIncrementorFunctionalExample.reactLive = {
    code: `function Component () {
            const [value, setValue] = React.useState("");
            const handleChange = val => {
                setValue(val);
            };
            return (
                <React.Fragment>
                    <SpsIncrementor onValueChange={handleChange} />
                    Value: {value}
                </React.Fragment>
            );
        }
        render(<Component />)`
};

function SpsIncrementorMinMaxExample(props) {
    const [value, setValue] = React.useState("");
    const handleChange = val => {
        setValue(val);
    };
    return (
        <React.Fragment>
            <SpsIncrementor min={0} max={10} onValueChange={handleChange} />
            Value: {value}
        </React.Fragment>
    );
}

// @ts-ignore
SpsIncrementorMinMaxExample.reactLive = {
    code: `function Component () {
            const [value, setValue] = React.useState("");
            const handleChange = val => {
                setValue(val);
            };
            return (
                <React.Fragment>
                    <SpsIncrementor min={0} max={10} onValueChange={handleChange} />
                    Value: {value}
                </React.Fragment>
            );
        }
        render(<Component />)`
};

function SpsIncrementorStepExample(props) {
    const [value, setValue] = React.useState("");
    const handleChange = val => {
        setValue(val);
    };
    return (
        <React.Fragment>
            <SpsIncrementor step={2} onValueChange={handleChange} />
            Value: {value}
        </React.Fragment>
    );
}

// @ts-ignore
SpsIncrementorStepExample.reactLive = {
    code: `function Component () {
            const [value, setValue] = React.useState("");
            const handleChange = val => {
                setValue(val);
            };
            return (
                <React.Fragment>
                    <SpsIncrementor step={2} onValueChange={handleChange} />
                    Value: {value}
                </React.Fragment>
            );
        }
        render(<Component />)`
};

export { SpsIncrementorFunctionalExample, SpsIncrementorMinMaxExample, SpsIncrementorStepExample };
